import { createContext, useContext } from 'react';

export const UserSettingsContext = createContext();

export const useUserSettings = () => useContext(UserSettingsContext);

export const UserSettingsModal = {
	ACCOUNT: 'ACCOUNT',
	GFX_LIBRARY: 'GFX_LIBRARY',
	VIDEO_IMAGE_LIBRARY: 'VIDEO_IMAGE_LIBRARY',
	MEMBERSHIP: 'MEMBERSHIP',
	LIBRARY: 'LIBRARY',
	INFO_CENTER: 'INFO_CENTER',
	KEY_LIBRARY: 'GREENKEY_LIBRARY',
	SELECT_VIDEOS: 'SELECT_VIDEOS',
	SELECT_IMAGES: 'SELECT_IMAGES',
	SURVEY_POLL: 'SURVEY_POLL',
	ANALYTICS_AND_ADVERTISING: 'ANALYTICS_AND_ADVERTISING',
	ANALYTICS_VOD_VIEW_MORE: 'ANALYTICS_VOD_VIEW_MORE',
	ANALYTICS_CHANNEL_VIEW_MORE: 'ANALYTICS_CHANNEL_VIEW_MORE',
};

export const InfoCenterModalTab = {
	TERMS_AND_PRIVACY: 'TERMS_AND_PRIVACY',
	COOKIE_POLICY: 'COOKIE_POLICY',
	HELP: 'HELP',
};

export const MyAccountModalTab = {
	SETTINGS: 'SETTINGS',
	DETAILS: 'DETAILS',
	OPERATORS: 'OPERATORS',
	QRCODE: 'QRCODE',
	NOTIFICATIONS: 'NOTIFICATIONS',
};

export const SurveyVoteTemplateTab = {
	SURVEY: 'SURVEY',
	VOTE_TEMPLATE: 'VOTE_TEMPLATE',
};

export const ResourceStatus = {
	ACTIVE: 'Active',
	ARCHIVED: 'Archived',
};

export const AnalyticsAndAdvertisingModalTab = {
	ANALYTICS: 'ANALYTICS',
	ADVERTISING: 'ADVERTISING',
};
